import { BottomNavigation, BottomNavigationAction, Dialog, DialogTitle, Grid, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';
import { Trans, useTranslation } from 'react-i18next';
import { Service } from '../../../store/service/types';
import { useGetServicesQuery } from '../../../store/service/serviceSlice';
import ErrorTypography from '../../../shared/ErrorTypography/ErrorTypography';
import { useState } from 'react';
import { SelectionT } from 'react-digraph';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { togglePauseTut } from '../../../store/tutorial/tutorialSlice';

type Props = {
  onCenterEdge: () => void;
  onEditEdge: (edgeSelected: boolean) => void;
  onAddEdge: (clicked: boolean) => void;
  onDelete: (selected: SelectionT) => void;

  onCenter: () => void;
  onEditService: (service: Service) => void; //we need service to put it into parameters of EditServiceDialog
  onAddService: (clickedService: boolean) => void;
  onEval: () => void;

  nodesSelected: number;
  edgesSelected: number;
  typeSelected: string | null;
  selected: SelectionT | null;
};

const BottomNavigationBar = ({
  onCenterEdge,
  onEditEdge,
  onAddEdge,
  onDelete,

  onCenter,
  onEditService,
  onAddService,
  onEval,

  nodesSelected,
  edgesSelected,
  typeSelected,
  selected,
}: Props): JSX.Element => {

  const { t } = useTranslation();
  const { data, error, isLoading } = useGetServicesQuery(undefined);
  const [value, setValue] = useState(0)
  const [open, setOpen] = useState(false);
  const tutorial = useAppSelector(state => state.tutorial)
  const dispatch = useAppDispatch();


  const handleClose = (success: boolean, value: string) => {
    if(success) {
      if(value == "Service") {
        onAddService(true);
      }
      if(value == "Edge") {
        if(tutorial.active) {
          if(!tutorial.paused && tutorial.actionSteps.includes(tutorial.stepIndex)) dispatch(togglePauseTut());
        }
        onAddEdge(true);
      }
    }
    setOpen(false);
  }

  const handleClickOpen = () => {
    console.log('trigger pause?');
    if(tutorial.active) {
      if(!tutorial.paused && tutorial.actionSteps.includes(tutorial.stepIndex)) dispatch(togglePauseTut());
    }
    setOpen(true);
  }

  if (!isLoading && data) {
    return (
      <>
      <Grid container spacing={0}>
        <Grid item xs={6}>
          <BottomNavigation showLabels>
            <BottomNavigationAction
              label={t("Center")}
              disabled={edgesSelected + nodesSelected !== 1}
              onClick={onCenter}
              icon={<CenterFocusStrongIcon color={edgesSelected + nodesSelected === 1 ? 'info' : 'disabled'} />}
            />
              <BottomNavigationAction
                label={t("Add")}
                onClick={handleClickOpen}
                className='add-action'
                icon={
                    <AddIcon color={'success'} />
              }
              />
            <BottomNavigationAction
              label={t("Delete (Del.)")}
              disabled={edgesSelected + nodesSelected === 0}
              onClick={()=>{
                if(selected) {onDelete(selected)}
              }}
              icon={<DeleteIcon color={edgesSelected + nodesSelected !== 0 ? 'error' : 'disabled'} />}
            />
            <BottomNavigationAction
              label={t("Edit")}
              disabled={edgesSelected + nodesSelected !== 1}
              onClick={()=>{
                if(selected) {
                  if(selected?.edges?.size !== undefined && selected?.edges?.size === 1) {
                    onEditEdge(true);
                  }
                  if(selected?.nodes?.size !== undefined && selected?.nodes?.size === 1) {
                    onEditService(data?.services.filter(service => service.service === typeSelected).values().next().value);
                  }
                }
              }}
              icon={<EditIcon color={edgesSelected + nodesSelected === 1 ? 'secondary' : 'disabled'} />}
            />
          </BottomNavigation>
        </Grid>
      </Grid>
      <Dialog onClose={() => {handleClose(false, "")}} open={open}>
        <DialogTitle><Trans>Add Edge or Service?</Trans></DialogTitle>
        <List>
          <ListItemButton 
            onClick={() => {handleClose(true, "Service")}}>
            <ListItemText primary={t("Service")} />
          </ListItemButton>
          <div className='addEdge-button'>
            <ListItemButton 
              onClick={() => {handleClose(true, "Edge")}}>
              <ListItemText primary={t("Edge")}/>
            </ListItemButton>
          </div>
        </List>
      </Dialog>
      </>
    );
    } else {
      return (
        <ErrorTypography message={t('Error fetching services.')} />
      );
    }
};

export default BottomNavigationBar;
